/**
 * Timeline Horizontal - Alpine.js component for horizontal timeline with Swiper
 * Requires: the shared Swiper bundle (lib/swiper.min.js). It is waited for, since scripts load async.
 */
import { whenSwiper } from '../lib/whenSwiper.js'

document.addEventListener('alpine:init', () => {
    Alpine.data('timelineHorizontal', (swiperId) => ({
        swiper: null,
        isBeginning: true,
        isEnd: false,
        currentSlide: 0,
        totalSlides: 0,
        currentSlideAnnouncement: '',

        init() {
            this.$nextTick(() => {
                this.initSwiper()
            })
        },

        initSwiper() {
            const swiperEl = document.getElementById(swiperId)
            if (!swiperEl) {
                console.warn('Timeline: swiper element not found', swiperId)
                return
            }
            // This used to bail out when Swiper had not loaded yet, which left the timeline dead
            // whenever the async scripts arrived in the other order.
            whenSwiper((Swiper, modules) => this.createSwiper(swiperEl, Swiper, modules))
        },

        createSwiper(swiperEl, Swiper, modules) {
            if (this.swiper) return

            this.swiper = new Swiper(swiperEl, {
                // lib/swiper.js no longer registers modules globally - each slider brings its own.
                modules: [modules.Keyboard, modules.A11y],
                slidesPerView: 1,
                spaceBetween: 24,
                grabCursor: true,
                keyboard: {
                    enabled: true,
                    onlyInViewport: true,
                },
                a11y: {
                    enabled: true,
                    prevSlideMessage: 'Previous timeline item',
                    nextSlideMessage: 'Next timeline item',
                    firstSlideMessage: 'This is the first timeline item',
                    lastSlideMessage: 'This is the last timeline item',
                },
                breakpoints: {
                    640: {
                        slidesPerView: 2,
                        spaceBetween: 24,
                    },
                    1024: {
                        slidesPerView: 3,
                        spaceBetween: 32,
                    },
                    1280: {
                        slidesPerView: 4,
                        spaceBetween: 32,
                    },
                },
                on: {
                    init: (swiper) => {
                        this.totalSlides = swiper.slides.length
                        this.updateState(swiper)
                    },
                    slideChange: (swiper) => {
                        this.updateState(swiper)
                    },
                },
            })
        },

        updateState(swiper) {
            this.isBeginning = swiper.isBeginning
            this.isEnd = swiper.isEnd
            this.currentSlide = swiper.activeIndex + 1
            this.currentSlideAnnouncement = `Showing item ${this.currentSlide} of ${this.totalSlides}`
        },

        prev() {
            if (this.swiper) {
                this.swiper.slidePrev()
            }
        },

        next() {
            if (this.swiper) {
                this.swiper.slideNext()
            }
        },

        goTo(index) {
            if (this.swiper) {
                this.swiper.slideTo(index)
            }
        },

        destroy() {
            if (this.swiper) {
                this.swiper.destroy()
                this.swiper = null
            }
        }
    }))
})
